module.exports = __webpack_public_path__ + "img/nt113-01-81-1.prt.8919f5ed.jpg";